import {
  Image,
  Box,
  Button,
  MediaFlex,
  Typography,
} from "@jewlr/storybook/core"
import styled from "styled-components"

export const GradientContainer = styled(Box).attrs((props) => ({
  px: "12px",
  py: 0,
  ...props,
}))`
  -webkit-overflow-scrolling: touch;
  position: relative;

  ${(props) =>
    !props.hideSlideShadow &&
    `
    &:after {
      background: #fff;
      content: " ";
      display: block;
      height: 100%;
      position: absolute;
      top: 0;
      width: 8%;
    }
    &:after {
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        #ffffff 95%
      );
      right: -8px;
    }
  `}

  ${(props) => props.theme.mediaQueries.tablet`
    padding: 0;
    &:after {
      display: none;
    }
  `}
`

export const OptionsLabel = styled(Typography).attrs((props) => ({
  bold: true,
  color: "black",
  fontSize: 14,
  ...props,
}))``

export const OptionsSlider = styled(MediaFlex).attrs((props) => ({
  flexWrap: { tablet: "wrap" },
  justifyContent: "flex-start",
  overflow: { _: "scroll hidden", tablet: "auto" },
  ...props,
}))`
  ${({ theme }) => theme.mediaQueries.tablet`
    &:last-child:after {
      display: none;
    }
  `}
`

export const OptionsSelect = styled(Box).attrs({
  as: "select",
})`
  width: 75%;
  padding: 0.5em 0.6em;
  background-color: #fff !important;
`

export const ChoiceOption = styled(Button).attrs((props) => ({
  border: { _: "1px solid transparent" },
  borderRadius: "5px",
  flexBasis: { _: "21%", tablet: "73px" },
  lineHeight: "12px",
  mb: "24px",
  mr: "4px",
  padding: "4px 2px 8px",
  textAlign: "center",
  variant: "text",
  ...props,
}))`
  border: 2px solid transparent;
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.15);
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: flex-start;
  transition: border 0.3s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid ${(props) => props.theme.colors.selected};
  }

  ${(props) =>
    props.selected &&
    `
    position: relative;
    border: 2px solid ${props.theme.colors.selected};
    box-shadow: 2px 4px 10px 0px rgba(0, 0, 0, 0.4);
    background-color: #fff;
    &:after {
      display: block;
      position: absolute;
      content: url(${require("images/icons/checkmark.svg")});
      transform: scale(0.05);
      bottom: -6px;
      left: 50%;
      margin-left: -18px;
      width: 22px;
      height: 22px;
    }
  `}
`
export const OptionImage = styled(Image).attrs((props) => ({
  height: "40px",
  ratio: "40 / 40",
  width: "40px",
  ...props,
}))``

export const OptionTitle = styled(Typography).attrs((props) => ({
  color: "grey.65",
  fontSize: "12px",
  mb: "7px",
  ml: "2px",
  mr: "2px",
  mt: "7px",
  ...props,
}))``
export const OptionPrice = styled(Typography).attrs((props) => ({
  color: "black",
  fontSize: { _: "11px", tablet: "12px" },
  fontWeight: "700",
  letterSpacing: "0.5px",
  ...props,
}))``

export const SkuIcon = styled(Box).attrs((props) => ({
  height: "48px",
  m: "0 auto 8px",
  width: "48px",
  ...props,
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.grey[20]};
  ${(props) =>
    props.skuColor === "Y" &&
    `
    background-color: #F8E7AD;
  `}
  ${(props) =>
    props.skuColor === "R" &&
    `
    background-color: #F4CEB2;
  `}
  ${(props) =>
    props.skuColor === "CE" &&
    `
    background-color: #646464;
    color: #fff;
  `}
  ${(props) =>
    props.skuColor === "W" &&
    `
    background-color: #EFEFEF;
  `}
  ${(props) =>
    props.skuColor === "V" &&
    `
    background-color: ${props.theme.colors.grey[20]};
    border: 8px solid #F8E7AD;
  `}
`

export const ErrorText = styled(Box).attrs({
  bg: "error",
  color: "white",
})`
  margin-bottom: 10px;
  padding: 5px;
  border-radius: 3px;
`
